import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { AuthLoading } from '@/components/auth/AuthGuard';
import AuthShell from '@/components/auth/AuthShell';

export default function PendingPage() {
  const { session, user, profile, loading, profileLoading, signOut, refreshProfile } = useAuth();
  const [checking, setChecking] = useState(false);

  if (loading) return <AuthLoading />;
  if (!session) return <Navigate to="/login" replace />;
  if (profileLoading) return <AuthLoading label="회원 정보를 확인하는 중이에요..." />;
  if (profile?.status === 'approved') return <Navigate to="/" replace />;

  const rejected = profile?.status === 'rejected';

  const handleCheck = async () => {
    setChecking(true);
    await refreshProfile();
    setChecking(false);
  };

  return (
    <AuthShell
      title={rejected ? '가입이 승인되지 않았어요' : '운영자 승인을 기다리는 중이에요'}
      subtitle={
        rejected
          ? '이 계정은 사용이 제한되었어요. 문의가 필요하면 운영자에게 연락해 주세요.'
          : '운영자가 가입 신청을 확인하고 승인하면 바로 사용할 수 있어요.'
      }
    >
      <div className="flex flex-col gap-4">
        <div
          className={`flex items-start gap-2.5 rounded-md border px-3.5 py-3 text-xs leading-relaxed ${
            rejected
              ? 'border-accent-200 bg-accent-50 text-accent-800'
              : 'border-secondary-200 bg-secondary-50 text-foreground-700'
          }`}
        >
          <i
            className={`mt-0.5 text-base ${
              rejected ? 'ri-close-circle-line text-accent-600' : 'ri-time-line text-secondary-700'
            }`}
          ></i>
          <div className="flex flex-col gap-1">
            <span className="font-bold">
              {rejected ? '상태: 승인 거절' : '상태: 승인 대기'}
            </span>
            <span>로그인 계정: {user?.email}</span>
          </div>
        </div>

        {!rejected && (
          <div className="flex flex-col gap-2 rounded-md border border-background-200 bg-background-50 px-3.5 py-3">
            <p className="text-xs font-semibold text-foreground-700">승인되었는지 확인하려면</p>
            <p className="text-xs leading-relaxed text-foreground-500">
              아래 버튼을 누르면 최신 승인 상태를 다시 확인해요. 승인되었다면 자동으로 오답노트 화면으로 이동해요.
            </p>
          </div>
        )}

        <div className="flex flex-col gap-2 sm:flex-row">
          {!rejected && (
            <button
              type="button"
              onClick={handleCheck}
              disabled={checking}
              className="flex flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {checking ? (
                <>
                  <i className="ri-loader-4-line animate-spin text-base"></i>
                  확인 중...
                </>
              ) : (
                <>
                  <i className="ri-refresh-line text-base"></i>
                  승인 상태 확인
                </>
              )}
            </button>
          )}
          <button
            type="button"
            onClick={() => void signOut()}
            className="flex flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm font-semibold text-foreground-700 transition hover:bg-background-100"
          >
            <i className="ri-logout-box-r-line text-base"></i>
            로그아웃
          </button>
        </div>
      </div>
    </AuthShell>
  );
}